<div
  [class.sh-card-table-wrapper]="!condensed"
  [class.-sh-sticky-columns]="!condensed"
  [class.digihaven-scroll-gradient]="!condensed && hasScrollableContent"
  [class.digihaven-scroll-gradient--start]="!condensed && hasScrolledFromStart"
  [class.sh-data-table-wrapper]="condensed"
>
  <ng-container *ngLet="{ rowActionItems: rowActionItems$ | async, columns: columns$ | async, records: records$ | async } as context">
    @if ((enableSelect$ | async) && selectionChanged.value.length > 0) {
      <digihaven-action-bar
        class="sh-sticky-header"
        [totalItemsCount]="context.records?.length"
        [selectedItemsCount]="selectionChanged.value.length"
        (shouldSelectAll)="toggleSelectAll($event)"
        [actionItems]="actionBarActionItems$ | async"
        [darkMode]="true"
        >
      </digihaven-action-bar>
    }
    @if (showBatchActions$ | async) {
      <digihaven-action-bar
        class="sh-sticky-header"
        [selectedItemsCount]="totalNumberOfResults"
        (shouldSelectAll)="toggleSelectAll($event)"
        [actionItems]="batchActionItemObservables"
        [allSelected]="true"
        [darkMode]="true"
      ></digihaven-action-bar>
    }
    @if (isLoading && !context.columns) {
      <table [class.sh-card-table]="!condensed" [class.sh-data-table]="condensed">
        <thead>
          <th scope="col"></th>
        </thead>
        <tbody>
          <tr>
            <td>{{ "ui.loading" | translate }}</td>
          </tr>
        </tbody>
      </table>
    }
    @if (context.columns) {
      <div
        #tableScroller
        [class.digihaven-card-table-scroller]="!condensed"
        (scroll)="onTableScroll($event)"
      >
        <table
          [class.sh-card-table]="!condensed"
          [class.sh-data-table]="condensed"
          >
          <thead [class.sh-card-table__header--context-actions]="!condensed">
            <tr>
              @if (enableSelect$ | async) {
                <th
                  scope="col"
                  [class.sh-card-table__col--small]="!condensed"
                  [class.sh-data-table__col--small]="condensed"
                  [class.digihaven-sticky-col--start]="!condensed"
                  >
                  @if (batchActionItems?.length) {
                    <sh-form-checkbox-with-dropdown
                      [id]="'selection-checkbox'"
                      [control]="selectAllCheckbox"
                      [canBeIndeterminate]="true"
                      [inverted]="false"
                      [options]="selectAllOptions"
                    ></sh-form-checkbox-with-dropdown>
                  }
                  @if (!batchActionItems?.length) {
                    <sh-form-checkbox [id]="'selection-checkbox'" [control]="selectPageCheckbox"></sh-form-checkbox>
                  }
                </th>
              }
              @for (column of context.columns; track column; let i = $index) {
                <th scope="col" [width]="column.columnDefinition.width">
                  <span [class.sh-visually-hidden]="!column.columnDefinition.showHeader">
                    {{ column.columnDefinition.label || (column.fieldDefinition | translateFieldDefinition) }}
                  </span>
                  @if (column.columnDefinition.sortable) {
                    <sh-column-sort
                      [columnDefinition]="getSortColumnDef(column)"
                      [currentSort]="currentSort"
                      (sortInfoChanged)="onSortInfoChanged($event)"
                    ></sh-column-sort>
                  }
                  @if (hasColumnFilter(column)) {
                    <sh-column-filter
                      [field]="column.columnDefinition.key"
                      [fieldType]="column.fieldDefinition?.Type"
                      [value]="getColumnFilterValue(column)"
                      [textFields]="getColumnFilterFields(column)"
                      [enumFacet]="getEnumFacet(column)"
                      [selectedEnumValues]="getSelectedEnumValues(column)"
                      (valueChanged)="onColumnFilterChanged(column.columnDefinition.key, $event)"
                      (fieldValueChanged)="onColumnFilterChanged($event.field, $event.value)"
                      (opened)="onEnumFilterOpened(column)"
                      (facetValueSelected)="facetValueSelected.emit($event)"
                      (enumCleared)="onEnumFilterCleared(column)"
                    ></sh-column-filter>
                  }
                </th>
              }
              @if (!!context.rowActionItems && context.rowActionItems.length > 0) {
                <th
                  scope="col"
                  [class.sh-card-table__col--small]="!condensed"
                  [class.sh-data-table__col--small]="condensed"
                  [class.sh-sticky-col--end]="!condensed"
                  >
                  {{ "ui.actions" | translate }}
                </th>
              }
            </tr>
          </thead>
          <tbody>
            @if (isLoading) {
              <tr>
                <td [attr.colspan]="columnCount$ | async">{{ "ui.loading" | translate }}</td>
              </tr>
            }
            @if (!isLoading && !hasError && (!context.records || context.records.length === 0)) {
              <tr>
                <td [attr.colspan]="columnCount$ | async">{{ "ui.no-results" | translate }}</td>
              </tr>
            }
            @if (hasError) {
              <tr class="sh-card-table__row--error">
                <td [attr.colspan]="columnCount$ | async">{{ "ui.errors.unknown" | translate }}</td>
              </tr>
            }
            @if (!isLoading && !hasError && context.records && context.records.length > 0) {
              @for (record$ of context.records; track record$; let row = $index) {
                <tr>
                  @if (record$ | async; as record) {
                    @if (enableSelect$ | async) {
                      <td [class.digihaven-sticky-col--start]="!condensed">
                        <input
                          class="sh-checkbox"
                          type="checkbox"
                          [checked]="isRowSelected(record)"
                          (click)="selectRow(record, row, $event)"
                          (keydown.enter)="selectRow(record, row, $event)"
                          />
                      </td>
                    }
                    @for (column of columns$ | async; track column; let index = $index) {
                      <td>
                        <digihaven-cell
                          [record]="record"
                          [column]="column"
                          [overviewId]="overviewId"
                          (rowNavigation)="recordSelected(record)"
                        ></digihaven-cell>
                      </td>
                    }
                    @if (context.rowActionItems?.length > 0) {
                      <td [class.sh-sticky-col--end]="!condensed" (click)="onRecordMenuSelected(record)">
                        @if (context.rowActionItems[row] | async; as actionItem) {
                          <sh-action-item [item]="actionItem"></sh-action-item>
                        }
                      </td>
                    }
                  }
                </tr>
              }
            }
          </tbody>
        </table>
      </div>
    }
  </ng-container>
</div>
